import app from '@/translations/resources/cs/app'

export const resources = {
    cs: {
        app,
    },
} as const
